module.exports = __WEBPACK_EXTERNAL_MODULE_10__;


//////////////////
// WEBPACK FOOTER
// external "oasi-main-theme/dist/oasi-main-theme.css"
// module id = 10
// module chunks = 0